import { render, staticRenderFns } from "./ExploreProducts.vue?vue&type=template&id=b4dffbaa&scoped=true"
import script from "./ExploreProducts.vue?vue&type=script&lang=js"
export * from "./ExploreProducts.vue?vue&type=script&lang=js"
import style0 from "./ExploreProducts.vue?vue&type=style&index=0&id=b4dffbaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dffbaa",
  null
  
)

export default component.exports